module.exports = __webpack_public_path__ + "img/yangming.e6b50945.jpg";